/**
 * «Octubre de 2026» a partir de un día civil como «2026-10-11».
 *
 * EL NOMBRE DEL MES NO SE TRADUCE A MANO. Serían ciento ocho textos —doce
 * meses por nueve idiomas— que además ya vienen en el navegador y en el
 * teléfono, escritos por quien sabe cómo se dice octubre en coreano.
 *
 * `timeZone: 'UTC'` Y LA FECHA ARMADA CON `Date.UTC` NO SON DECORACIÓN. Un
 * día civil no es un instante: `new Date('2026-10-01')` es la medianoche UTC,
 * y formateada con la zona de un teléfono en Costa Rica —seis horas atrás—
 * cae el 30 de septiembre. Un torneo de octubre apareciendo en septiembre es
 * exactamente el tipo de error que nadie revisa porque «la fecha está bien en
 * la base».
 *
 * Si el idioma no le gusta a `Intl` —uno inventado, o un navegador viejo—,
 * devuelve «2026-10», que es feo pero cierto. Una pantalla que revienta por
 * el nombre de un mes es peor.
 */
export function monthYear(isoDate: string, locale: string): string {
  const [year, month] = isoDate.split('-');
  if (year === undefined || month === undefined) return isoDate;

  const y = Number(year);
  const m = Number(month);
  if (!Number.isFinite(y) || !Number.isFinite(m) || m < 1 || m > 12) return isoDate;

  try {
    return new Intl.DateTimeFormat(locale, {
      month: 'long',
      year: 'numeric',
      timeZone: 'UTC',
    }).format(new Date(Date.UTC(y, m - 1, 1)));
  } catch {
    return `${year}-${month}`;
  }
}

/** El año de un día civil, o `null` si no se entiende. */
export function yearOf(isoDate: string): number | null {
  const year = Number(isoDate.split('-')[0]);
  return Number.isFinite(year) ? year : null;
}
